import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/vehiclepositioninganomalyanalysisresultserv'

export default {
  state: {
    state_VehiclePositioningAnomalyAnalysisResult_GetPageResult: null,
    state_VehiclePositioningAnomalyAnalysisResult_GetDetailResult: null,
    state_VehiclePositioningAnomalyAnalysisResult_GetClientPageResult: null,
    state_VehiclePositioningAnomalyAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_VehiclePositioningAnomalyAnalysisResult_GetPageResult = rst;
    },
    SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehiclePositioningAnomalyAnalysisResult_GetDetailResult = rst;
    },
    SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_VehiclePositioningAnomalyAnalysisResult_GetClientPageResult = rst;
    },
    SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_VehiclePositioningAnomalyAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    VehiclePositioningAnomalyAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehiclePositioningAnomalyAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehiclePositioningAnomalyAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehiclePositioningAnomalyAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEPOSITIONINGANOMALYANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehiclePositioningAnomalyAnalysisResult_GetPageResult: state => {
      return state.state_VehiclePositioningAnomalyAnalysisResult_GetPageResult;
    },
    get_VehiclePositioningAnomalyAnalysisResult_GetDetailResult: state => {
      return state.state_VehiclePositioningAnomalyAnalysisResult_GetDetailResult;
    },
    get_VehiclePositioningAnomalyAnalysisResult_GetClientPageResult: state => {
      return state.state_VehiclePositioningAnomalyAnalysisResult_GetClientPageResult;
    },
    get_VehiclePositioningAnomalyAnalysisResult_ExportExcelResult: state => {
      return state.state_VehiclePositioningAnomalyAnalysisResult_ExportExcelResult;
    },
  }
}